<template>
  <!--<div>-->
    <v-layout align-center>
      <v-flex
        @dragover.stop.prevent="onDragOver($event, -1, true)"
        @drop="onDrop"
        style="width: calc(100% - 36px)"
      >
        <v-tabs :color="dark ? 'grey darken-4':'grey lighten-3'" :value="current" height="36px" hide-slider
                show-arrows v-if="length > 0">
          <template v-for="(t, i) in list">
            <v-tab
              :class="[current === i ? dark ? 'grey darken-3 primary--text':'grey lighten-5 primary--text':'']"
              :draggable="t.persistent ? 'false':'true'"
              :key="i"
              @click="$L.tab.push(t)"
              @dragend.native="onDragEnd($event, i)"
              @dragover.stop.prevent="onDragOver($event, i)"
              @dragstart.native="onDragStart($event, i)"
              @drop.stop="onDrop($event, i)"
              v-show="dragIndex !== i || dropIndex === dragIndex || dragIndex < 0"
            >
              <v-layout align-center>
                <v-flex class="px-2 text-truncate">{{t.label}}</v-flex>
                <span class="pr-2 grey--text caption text-truncate" style="max-width: 10em"
                      v-if="t.desc">{{t.desc}}</span>
                <v-btn
                  @click.stop="checkClose(i, t)"
                  class="ml-2 mr-0"
                  icon
                  small
                  v-if="!t.persistent"
                >
                  <v-icon clickable small>mdi-close</v-icon>
                </v-btn>
              </v-layout>
            </v-tab>
            <v-divider :class="dropIndex === i ? 'primary': ''" :key="i + 'd'" style="" vertical></v-divider>
            <template
              v-if="dropIndex === i && dropIndex !== dragIndex && dragIndex >=0"
            >
              <v-tab
                :class="dark ? 'grey darken-3':'grey lighten-4'"
                :key="i + 'p'"
              >
                <v-flex class="px-2 text-truncate">{{dragItem.label}}</v-flex>
                <span class="pr-2 grey--text caption text-truncate" style="max-width: 10em"
                      v-if="dragItem.desc">{{dragItem.desc}}</span>
                <v-btn
                  class="ml-2 mr-0"
                  icon
                  small
                  disabled
                  v-if="!dragItem.persistent"
                >
                  <v-icon clickable small>mdi-close</v-icon>
                </v-btn>
              </v-tab>
              <v-divider :key="i + 'd2'" class="primary" vertical></v-divider>
            </template>
          </template>
        </v-tabs>
      </v-flex>
      <v-divider vertical></v-divider>
      <div :class="dark ? 'grey darken-4':'grey lighten-3'"
           style="width: 36px; height: 36px">
        <v-layout align-center fill-height justify-center>
          <v-menu close-delay="300ms" open-on-hover offset-y left min-width="80px">
            <v-icon clickable color="grey" size="20px" slot="activator">mdi-close-circle-outline</v-icon>
            <v-list dense>
              <v-list-tile @click="$L.tab.clearAll()">
                关闭所有
              </v-list-tile>
              <v-list-tile @click="$L.tab.clearOther()">
                关闭其他
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-layout>
      </div>
    </v-layout>
    <!--<v-layout>-->
    <!--  <v-flex>-->
    <!--    {{$L.tab.list.map(t => t.tid)}}||{{$L.tab.current}}||{{dragIndex}}||{{dropIndex}}-->
    <!--  </v-flex>-->
    <!--</v-layout>-->
  <!--</div>-->
</template>

<script>
import BCFunctions from '@/router/beforeClose'
import throttle from 'lodash/throttle'
// TODO: 不使用Vuetify的Tab Pagination，重写以支持js控制，来支持拖放tab

export default {
  name: 'LRouterTabs',
  data: () => ({
    dragIndex: -1,
    dropIndex: -1,
  }),
  computed: {
    list () {
      return this.$L.tab.list
    },
    current () {
      return this.$L.tab.current
    },
    length () {
      return this.list.length
    },
    dark () {
      return this.$vuetify.dark
    },
    dragItem () {
      return this.list[this.dragIndex] || {}
    },
  },
  methods: {
    onDragStart (e, i) {
      this.dragIndex = i
      this.dropIndex = i
      // console.log('start', i)
    },
    onDragOver: throttle(function (e, i, isContainer) {
      if (isContainer) {
        this.dropIndex = this.list.length - 1
      }
      else {
        this.dropIndex = i
      }
      // console.log('over', this.dropIndex)
    }, 100),
    onDragEnd (e, i) {
      this.$nextTick(() => {
        this.dragIndex = -1
        this.dropIndex = -1
        // console.log('end', i)
      })
    },
    onDrop (e, i) {
      // console.log('drop', this.dropIndex)
      this.$L.tab.move(this.dragIndex, this.dropIndex)
    },
    async checkClose (i, t) {
      let f = BCFunctions[t.beforeCloseName]
      if (t.beforeCloseName && t.beforeCloseName instanceof Function) {
        let v = await f()
        // console.log('return', v)
        if (v) {
          this.$L.tab.close(i)
        }
      }
      else {
        this.$L.tab.close(i)
      }
    },
  },
  created () {
    const persistent = [this.$router.match('/')]
    this.$L.tab.readFromLocal(persistent, this.$route)
    let currentTab = this.list.find(t => t.to === this.$route.fullPath)
    if (currentTab) {
      this.$L.tab.replace(currentTab)
    }
    // this.$L.tab.go = this.go
  },
  beforeDestroy () {
    this.$L.tab.clearAll()
  }
}
</script>

<style scoped>

</style>
